<template>
  <div class="sidebar-container">
    <div class="logo">
      <Logo />
    </div>
    <div class="title">
      <span>Pension Keeper Dashboard</span>
      <div @click="isOpenMobileMenu = !isOpenMobileMenu" class="burger">
        <VIcon v-if="isOpenMobileMenu" icon="mdi-menu-open" color="primary"></VIcon>
        <VIcon v-else icon="mdi-menu-close" color="primary"></VIcon>
      </div>
    </div>
    <template v-if="isOpenMobileMenu">
      <div class="hr"></div>
      <div class="profile">Hi, {{ application.firstName + ' ' + application.lastName }}</div>

      <div class="hr"></div>
      <div class="nav-links">
        <template v-for="linkItem in items" :key="linkItem">
          <router-link :to="linkItem.link">{{ linkItem.title }}</router-link>
        </template>
      </div>
      <div class="hr"></div>
      <div class="nav-links">
        <template v-for="linkItem in subitems" :key="linkItem">
          <router-link :to="linkItem.link">{{ linkItem.title }}</router-link>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
// Components
import Logo from '@/components/common/Logo/Logo.vue';
// Service
import applicationService from '@/services/application-service/application.service';
export default {
  name: 'AppDrawer',
  components: {
    Logo
  },
  watch: {
    $route: {
      handler() {
        // Only close on mobile devices when menu is open
        if (this.isMobile && this.isOpenMobileMenu) {
          this.isOpenMobileMenu = false;
        }
      },
      immediate: false
    }
  },
  computed: {
    ...mapGetters('user', ['application']),
    isMobile() {
      return window.innerWidth < 768;
    },
    menus() {
      if (this.drawerProps.railWidth === 256) {
        return this.items;
      } else {
        return this.items.filter((item) => item.type !== 'subheader');
      }
    },
    subitems() {
      return [
        // { link: { name: 'UK Tax Questions' }, title: 'UK Tax Questions' },
        { link: { name: 'Have 30+ Years?' }, title: 'Have 30+ Years?' },
        // {
        //   link: {
        //     name:
        //       this.application.currentAddress.country === 'Ireland'
        //         ? 'Do You Have a Private UK Pension?'
        //         : 'Your Personal and Occupational Pensions'
        //   },
        //   title: 'Private UK Pension?'
        // },
        { link: { name: 'Private UK Pension?' }, title: 'Private UK Pension?' },
        { link: { name: 'Had Kids in the UK?' }, title: 'Had Kids in the UK?' },
        { link: { name: 'Parents Worked in UK?' }, title: 'Parents Worked in UK?' },
        // {
        //   link: { name: 'Your Friend/Family got a Class 3 Approval Letter but think it’s wrong?' },
        //   title: 'Class 3 Appeals'
        // },
        { link: { name: 'Contact Us' }, title: 'Contact Us' },
        { link: { name: 'Billing' }, title: 'Billing' },
        { link: { name: 'Logout' }, title: 'Logout' }
      ];
    }
  },
  data() {
    return {
      isOpenMobileMenu: true,
      items: [
        { link: { name: 'Buying Future Years' }, title: 'Critical: Future Years' },
        { link: { name: 'Overview' }, title: 'Overview' },
        { link: { name: 'Check Your Entitlement' }, title: 'Check your Entitlement' },
        {
          link: {
            name: 'How to Pay HMRC to Buy Another Year'
          },
          title: 'How to Pay'
        },
        { link: { name: 'Personal Details' }, title: 'Update your Information' },
        { link: { name: 'Your Documents' }, title: 'Your Documents' },
        { link: { name: 'Latest Comments From Us' }, title: 'Latest Comms' },
        // { link: { name: 'Frequently Asked Questions' }, title: 'FAQ' },
        { link: { name: 'Useful Phone Numbers (HMRC / DWP)' }, title: 'Useful Tel Nos' }
      ]
    };
  },
  mounted() {
    this.getProfileInfo();
    if (this.isMobile) {
      this.isOpenMobileMenu = false;
    }
  },
  methods: {
    ...mapActions('user', ['updateUserApplication']),
    async getProfileInfo() {
      try {
        const { application } = await applicationService.getApplicationDetails();
        if (application?.id) {
          this.updateUserApplication(application);
        }
      } catch (err) {
        console.error(err);
      }
    },
    handleDrawerWidth() {
      const rail = this.drawerProps.rail;
      const railWidth = this.drawerProps.railWidth;
      this.drawerProps.rail = !rail;
      this.drawerProps.railWidth = railWidth === 62 ? 256 : 62;
      this.drawerProps.icon = this.drawerProps.railWidth === 256 ? 'mdi-arrow-expand-left' : 'mdi-arrow-expand-right';
    },
    goToWebsite() {
      window.open('https://www.xtrapension.com/', '_blank');
    }
  }
};
</script>
<style lang="scss">
.btn-collapse {
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
}
</style>
